import { LOCALES } from '../constants';

export default {
  [LOCALES.FRENCH]: {
    // new one
    'pagination':'pagination',
    'header':'en-têtes',
    'toolbar':'Barre d\'outils',
    'body':'organisme',
    // Side Menue
    "Project Management":"Gestion de Projet",
    'Dashboard':'Tableau de bord',
    'Calendar':'Calendrier',
    'Kanban':'Kanban',
    'TimeLine':'TimeLine',
    'GANTT':'GANTT',
    'Notifications':'Notifications',
    'User Profile':'Profil de l\'utilisateur',
    // Create Project selector
    'Project type':'Type de projet',
    // Spreadsheet Column
    'Tasks ERP':'Tâches ERP',
    'Hardware':'Matériel',
    'Source':'Source',
    'Start':'Début',
    'Subject':'Sujet',
    'Assigned To':'Assigné à',
    'Due Date':'Date d\'échéance',
    'Active?':'Active?',
    'Status':'Status',
    'Progress':'Progrès',
    'Priority':'Priorité',
    'Notes':'Notes',
    // Spreadsheet Action
    'Show last Modified':'Afficher la dernière modification',
    'Import Rows from csv':'Importer des lignes depuis csv',
    'Toogle single cell editing':'Toogle single cell editing',
    'Delete Multipe':'Supprimer plusieurs',
    'Remove All Selected Tasks':'Supprimer toutes les tâches sélectionnées',
    'Export':'Exportation',
    'Actions':'Actions',
    'no record to display':'aucun enregistrement à afficher',
    'Add':'Ajouter',
    "Add Task":"Add une tache",
    'Delete':'Suprimer',
    'Delete multipe':'Supression multipe',
    'Permanent delete':'Supression permanente',
    'Edit':'Éditer',
    'Are you sure delete this row?':'Êtes-vous sûr de supprimer cette ligne?',
    'Cancel':'Annuler',
    'Save':'sauvegarder',
    'Search':'Chercher',
    'rows':'lignes',
    'First page':'Première page',
    'Previous':'Précédent',
    'Next':'Prochain',
    'Last page':'Dernière page',
    'of':'de',
    'Export to CSV':'Exportation en CSV',
    'Export to PDF':'Exportation en PDF',
    // csv Sync
    'Sync header field here with mode':'Synchroniser le champ d\'en-tête ici avec le mode',
    // ProjectKPI
    'Project Road Map':'Feuille de route du projet',
    'Team member: ':'Membre de l\'équipe: ',
    'Tasks Status':'État des tâches',
    'Tasks Average Progress':'Progression moyenne des tâches',
    'Remaining days :':'Jours restants :',
    'Task completed':'Tâches terminées',
    'Assigned':'Attribué',
    'InProgress':'En cours',
    'InReview':'En revue',
    'Completed':'Terminé',
    'Suspended':'Suspendue',
    // Project Selector
    'Modify':'Modifier',
    'Add project':'Ajouter projet',
    'Project':'Project',
    'Select project':'Sélectionner projet',
    'Project owner':'Propriétaire du Projet',
    'Collaborator':'Collaborateur',
    'Not allowed for guest':'Non autorisé pour les invités',
    'Delete forever ?':'Supprimer pour toujours ?',
    // Cash fiancial Scenario Selector
    'Scenario':'Scenario',
    'Select scenario':'Sélectionner scenario',
    'Scenario owner':'Propriétaire du scénario',
    'Add scenario':'Ajouter scenario',
    "Category":"Category",
    "Title":"Titre",
    "Date":"Date",
    "Amount":"montant",
    "Descriptions":"Descriptions",
    "Income":"Income",
    "Expense":"Expense",
    "Balance":"Balance",
    "Add Income":"Add Income",
    "Add Expense":"Add Expense",
    "Daily Flow":"Daily Flow",
    "Annual Report":"Annual Report",
    "Today":"Today",
    "Actual Cash Flow":" Cash Flow Actuelle",
    "Treasury":"Treasury",
    "Monthly":"mensuelle",
    // Notification Page
    'Activity':'Activité',
    'Today Activity':'Activité d\'aujourd\'hui',
    'demo-placeholder': 'Échantillon d\'espace réservé',
    // Others
    'Close':'Fermer',
    'Submit':'Soumettre',
    'ok':'ok',
    'Open':'Ouvert',
    'Available':',Available',
    'Sign out':'Sign out',
    'Home':'Accueil',
    'organisation':'organisation',
    'Welcome':'Bienvenu',
    'Created':'Établi',
    'Updated':'Mis à jour',
    'email':'email',
    'Address':'Address',
    'Title':'Titre',
    'id':'id',
    'Id':'Id',
    'New':'Nouveaux',
    // other ERP Module/Departement
    'CRM':'CRM',
    "Contact Lists":"Contact Lists",
    "Activities":"Activities",
    "Deals":"Deals",
    "clients":"clients",
    "companies":"companies",
    "start":"start",
    "finish":"finish",
    "type":"type",
    "pipeline":"pipeline",
    'Cash Flow':'Flux de trésorerie',
    'Test Components':'Test Components',
  },
};
